import { i18n } from '@/plugins/i18n'

const fields = [
    {
        key: 'name',
        label: i18n.t('tag.name'),
    },
    {
        key: 'stores_count',
        label: i18n.t('tag.stores_count'),
    },
    {
        key: 'users_count',
        label: i18n.t('tag.users_count'),
    },
    {
        key: 'createdAt',
        label: i18n.t('attributes.created_at'),
    },
    // {
    //     key: 'actions',
    //     label: i18n.t('actions'),
    //     _classes: 'text-center',
    // },
]

export default fields

export const sorts = [
    {
        label: i18n.t('sorter.desc', {attr: i18n.t('attributes.created_at')}),
        value: {
            direction: 'desc',
            column: 'id'
        }
    },
    {
        label: i18n.t('sorter.asc', {attr: i18n.t('attributes.created_at')}),
        value: {
            direction: 'asc',
            column: 'id'
        }
    },
    {
        label: i18n.t('sorter.desc', {attr: i18n.t('tag.count')}),
        value: {
            direction: 'desc',
            column: 'count'
        }
    },
    {
        label: i18n.t('sorter.asc', {attr: i18n.t('tag.count')}),
        value: {
            direction: 'asc',
            column: 'count'
        }
    },
]